import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    EPIC,
    GRANT,
    PROXY_APPROVED,
    PROXY_CANCELLED,
    PROXY_DELETE,
} from '../../constants/textConstants';
import { logUI } from '../../api/andyliticsApi';
import * as ProxyHelper from './ProxyHelper';
import * as Tools from '../../helpers/Tools';
import * as types from '../../constants/actionTypes';
import * as msgs from "../../constants/textConstants";
import MiniSpinner from '../common/MiniSpinner';
import PropTypes from 'prop-types';
import { Modal } from '../ecosystem';
import ActiveListProxy from './ActiveListProxy';
import SuccessMsg from './home/SuccessMsg';
import ErrorMsg from './home/ErrorMsg';
import RemoveMsg from './home/RemoveMsg';
import AcceptGrantMsg from './home/AcceptGrantMsg';

const propTypes = {
    actionType: PropTypes.string,
    age: PropTypes.number,
    approvedRequest: PropTypes.object,
    approvedRequestSuccess: PropTypes.bool,
    changeRequestStatus: PropTypes.func,
    declineProxyWithReason: PropTypes.bool,
    deleteAction: PropTypes.object,
    emailProxyRequestId: PropTypes.string,
    grantOrManagerList: PropTypes.array,
    grantOrSubjectList: PropTypes.array,
    isApprovePending: PropTypes.bool,
    proxySource: PropTypes.string,
    referrer: PropTypes.string,
    removePharmacyAction: PropTypes.object,
    requestList: PropTypes.array,
    showGrantProxyAccess: PropTypes.bool,
};

class ActiveList extends Component {
    constructor(props) {
        super(props);
        this.state = { removing: null, isManager: 'undefined', referrer: '' };
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {
        const { proxySource } = this.props;

        logUI(
            `MBHWeb.UI.${ProxyHelper.getLogProxySource(
                proxySource
            )}.ActiveList.ComponentDidMount`,
            new Date(),
            Tools.getURLPath()
        );
    }

    onRemove(removing, isManager = 'undefined', referrer = '') {
        this.setState({ removing, isManager, referrer });
    }

    onRemoveConfirmed(yesRemove) {
        const { removing } = this.state;
        const { changeRequestStatus, declineProxyWithReason } = this.props;
        const statusForProxyUpdate = declineProxyWithReason
            ? PROXY_DELETE
            : PROXY_CANCELLED;

        if (yesRemove) {
            changeRequestStatus(
                removing.ProxyRequestId,
                removing.ProxySource,
                removing.RequestType,
                statusForProxyUpdate
            );

            logUI(
                `MBHWeb.${ProxyHelper.getLogProxySource(
                    removing.ProxySource
                )}.Proxy.RemoveAccess`,
                new Date(),
                Tools.getURLPath(),
                JSON.stringify({ proxyRequestId: removing.ProxyRequestId })
            );
        }

        this.setState({ removing: null, removingConfirmed: removing });
    }

    getMessage(removing) {
        let infoModal = false;
        let displayName =
            removing.LastName !== null
                ? `${removing.FirstName} ${removing.LastName}`
                : removing.FirstName;

        displayName = displayName.trim();

        let message = '';

        const { isManager, referrer } = this.state;
        const infoModalMsg = (
            <>
                <p>
                    BSWH, Health Information Management Department, Mail Stop 01047
                    <br />
                    2401 S. 31st Street
                    <br />
                    Temple, TX 76508{' '}
                </p>
                <p>
                    Fax:{' '}
                    <a href='tel:254.724.0119' className='phone-link'>
                        254.724.0119
                    </a>
                </p>
                <p>
                    <br />
                    <strong>Or for Health Texas Provider Network (HTPN) Patients:</strong>
                </p>
                <p>
                    Health Information Management department
                    <br />
                    8150 N. Central Expressway, Suite 400, Box 47
                    <br />
                    Dallas, TX 75206
                </p>
                <p>
                    Fax:{' '}
                    <a href='tel:214.818.9781' className='phone-link'>
                        214.818.9781
                    </a>
                </p>
            </>
        );

        const recordType =
            typeof removing.ProxySource !== 'undefined' &&
                removing.ProxySource.toLowerCase() === EPIC
                ? 'medical'
                : 'pharmacy';

        const removeMyMedicalRecordAccessMsg = `To remove access to ${displayName}’s medical records, please send written notice to:`;
        const removeMyRecordAccessMsg = `Are you sure you want to remove access to ${displayName}’s ${recordType} records?`;
        const removeTheirMedicalRecordAccess = `To remove ${displayName}’s access to your medical records, please send written notice to:`;
        const removeTheirRecordAccessMsg = `Are you sure you want to remove ${displayName}’s access to your ${recordType} records?`;

        if (isManager !== 'undefined') {
            if (
                removing.RequestType &&
                removing.RequestType.toLowerCase() === GRANT
            ) {
                if (isManager) {
                    if (removing.ProxyRequestId !== null) {
                        message = removeMyRecordAccessMsg;
                    } else {
                        infoModal = true;
                        message = removeMyMedicalRecordAccessMsg;
                    }
                } else {
                    if (removing.ProxyRequestId !== null) {
                        message = removeTheirRecordAccessMsg;
                    } else {
                        infoModal = true;
                        message = removeTheirMedicalRecordAccess;
                    }
                }
            }
        } else {
            if (referrer === 'subject') {
                if (
                    typeof removing.ProxySource !== 'undefined' &&
                    removing.ProxySource.toLowerCase() === EPIC &&
                    removing.ProxyRequestId === null
                ) {
                    infoModal = true;
                    message = removeMyMedicalRecordAccessMsg;
                } else {
                    message = removeMyRecordAccessMsg;
                }
            } else {
                message = removeTheirRecordAccessMsg;
            }
        }

        return infoModal ? (
            <>
                <p>
                    <strong>{message}</strong>
                </p>{' '}
                {infoModalMsg}
            </>
        ) : (
            message
        );
    }

    toggleModal() {
        this.setState({ removing: null });
    }

    render() {
        const {
            actionType,
            age,
            approvedRequest,
            approvedRequestSuccess,
            deleteAction,
            emailProxyRequestId,
            grantOrManagerList,
            grantOrSubjectList,
            isApprovePending,
            referrer,
            removePharmacyAction,
            requestList,
            showGrantProxyAccess,
        } = this.props;
        const removeAction = removePharmacyAction;
        const { removing, removingConfirmed } = this.state;

        const isAdult = age && age > 17 ? true : false;
        const emailProxyRequest =
            (grantOrManagerList &&
                grantOrManagerList.find(
                    el => el.ProxyRequestId == emailProxyRequestId
                )) ||
            (grantOrSubjectList &&
                grantOrSubjectList.find(
                    el => el.ProxyRequestId == emailProxyRequestId
                ));
        const emailProxyRequestIdExists =
            emailProxyRequestId && emailProxyRequest ? true : false;

        return (
            <>
                <AcceptGrantMsg
                    referrer={referrer}
                    actionType={actionType}
                    emailProxyRequestIdExists={emailProxyRequestIdExists}
                    isApprovePending={isApprovePending}
                    approvedRequestSuccess={approvedRequestSuccess}
                    approvedRequest={approvedRequest}
                />

                {referrer &&
                    referrer !== 'acceptgrant' &&
                    requestList &&
                    requestList.map((proxyAccess, index) => {
                        const expiresOn = showGrantProxyAccess
                            ? proxyAccess.ExpireOn
                            : proxyAccess.ed;
                        const showExpiresOn =
                            new Date().getTime() + 365 * 24 * 60 * 60 * 1000 >
                            new Date(expiresOn);
                        const isWaiting =
                            removingConfirmed &&
                            deleteAction &&
                            deleteAction.waiting &&
                            deleteAction.request &&
                            deleteAction.request.proxyRequestId ===
                            proxyAccess.ProxyRequestId;
                        const deleteErrorMessage =
                            removingConfirmed &&
                                deleteAction &&
                                deleteAction.error !== null &&
                                !deleteAction.success &&
                                !deleteAction.waiting &&
                                deleteAction.request &&
                                deleteAction.request.proxyRequestId === proxyAccess.ProxyRequestId
                                ? deleteAction.errorMessage &&
                                    deleteAction.errorMessage !== null
                                    ? deleteAction.errorMessage
                                    : "We're unable to delete the request. Please try again later."
                                : '';

                        if (!proxyAccess.displayName && proxyAccess.FirstName) {
                            proxyAccess.displayName = `${proxyAccess.FirstName} ${proxyAccess.LastName}`;
                        }

                        return (
                            <React.Fragment key={index}>
                                <ActiveListProxy
                                    name={proxyAccess.displayName}
                                    message={<>
                                        {deleteErrorMessage && !isWaiting &&
                                            <ErrorMsg
                                                message={deleteErrorMessage}
                                            />
                                        }
                                        {(referrer === 'proxy' || referrer === 'subject') &&
                                            proxyAccess.MessageNote &&
                                            proxyAccess.MessageNote !== null && (
                                                <SuccessMsg
                                                    message={proxyAccess.MessageNote}
                                                />
                                            )
                                        }
                                    </>}
                                    circleBtn={(!removeAction || !removeAction.waiting) && referrer !== 'acceptgrant' && isAdult
                                        ? {
                                            label: "Remove",
                                            onClick: () => {
                                                    this.onRemove(proxyAccess, 'undefined', referrer)
                                                },
                                            tooltipId: `request-list-remove-${index}`
                                        }
                                        : ''}
                                    expiresOn={expiresOn && showExpiresOn ? expiresOn : ""}
                                    isWaiting={isWaiting}
                                />
                            </React.Fragment>
                        );
                    })}

                {grantOrManagerList &&
                    grantOrManagerList.map((manager, index) => {
                        const displayName = showGrantProxyAccess
                            ? manager.FirstName +
                            ' ' +
                            (manager.LastName !== null ? manager.LastName : '')
                            : manager.displayName;
                        const expiresOn = showGrantProxyAccess
                            ? manager.ExpireOn
                            : manager.ed;
                        const showExpiresOn =
                            new Date().getTime() + 365 * 24 * 60 * 60 * 1000 >
                            new Date(expiresOn);
                        const isWaiting = 
                            removingConfirmed &&
                            deleteAction &&
                            deleteAction.waiting &&
                            deleteAction.request &&
                            deleteAction.request.proxyRequestId === manager.ProxyRequestId;
                        const deleteErrorMessage =
                            removingConfirmed &&
                                deleteAction &&
                                deleteAction.error !== null &&
                                !deleteAction.success &&
                                !deleteAction.waiting &&
                                deleteAction.request &&
                                deleteAction.request.proxyRequestId === manager.ProxyRequestId
                                ? deleteAction.errorMessage &&
                                    deleteAction.errorMessage !== null
                                    ? deleteAction.errorMessage
                                    : "We're unable to delete the request. Please try again later."
                                : '';

                        return (
                            <React.Fragment key={index}>
                                <ActiveListProxy
                                    name={displayName}
                                    message={<>
                                        {deleteErrorMessage && !isWaiting &&
                                            <ErrorMsg
                                                message={deleteErrorMessage}
                                            />
                                        }
                                        {manager?.MessageNote && manager?.MessageNote !== null &&
                                            <SuccessMsg
                                                message={manager?.MessageNote}
                                            />
                                        }
                                    </>}
                                    circleBtn={showGrantProxyAccess
                                        ? {
                                            label: "Remove",
                                            onClick: () => {
                                                this.onRemove(manager, false)
                                            },
                                            tooltipId: `grant-manager-list-remove-${index}`
                                        }
                                        : ''}
                                    expiresOn={expiresOn && showExpiresOn ? expiresOn : ""}
                                    isWaiting={isWaiting}
                                />
                            </React.Fragment>
                        );
                    })}

                {grantOrSubjectList &&
                    grantOrSubjectList.map((subject, index) => {
                        const displayName = showGrantProxyAccess
                            ? subject.FirstName +
                            ' ' +
                            (subject.LastName !== null ? subject.LastName : '')
                            : subject.displayName;
                        const expiresOn = showGrantProxyAccess
                            ? subject.ExpireOn
                            : subject.ed;
                        const showExpiresOn =
                            new Date().getTime() + 365 * 24 * 60 * 60 * 1000 >
                            new Date(expiresOn);
                        const isWaiting = 
                            removingConfirmed &&
                            deleteAction &&
                            deleteAction.waiting &&
                            deleteAction.request &&
                            deleteAction.request.proxyRequestId === subject.ProxyRequestId;
                        const deleteErrorMessage =
                            removingConfirmed &&
                                deleteAction &&
                                deleteAction.error !== null &&
                                !deleteAction.success &&
                                !deleteAction.waiting &&
                                deleteAction.request &&
                                deleteAction.request.proxyRequestId === subject.ProxyRequestId
                                ? deleteAction.errorMessage &&
                                    deleteAction.errorMessage !== null
                                    ? deleteAction.errorMessage
                                    : "We're unable to delete the request. Please try again later."
                                : '';

                        return (
                            <React.Fragment key={index}>
                                <ActiveListProxy
                                    name={displayName}
                                    message={<>
                                        {deleteErrorMessage && !isWaiting &&
                                            <ErrorMsg
                                                message={deleteErrorMessage}
                                            />
                                        }
                                        {/*For accepting grants show success message from accepting grant instead of from message note*/}
                                        {/*subject?.MessageNote && subject?.MessageNote !== null &&
                                            <SuccessMsg
                                                message={subject?.MessageNote}
                                            />
                                        */}
                                    </>}
                                    circleBtn={showGrantProxyAccess
                                        ? {
                                            label: "Remove",
                                            onClick: () => {
                                                this.onRemove(subject, true)
                                            },
                                            tooltipId: `grant-subject-list-remove-${index}`
                                        }
                                        : ''}
                                    expiresOn={expiresOn && showExpiresOn ? expiresOn : ""}
                                    isWaiting={isWaiting}
                                />
                            </React.Fragment>
                        );
                    })}

                {removing && (
                    <>
                        {showGrantProxyAccess &&
                            removing !== null &&
                            removing.ProxyRequestId === null &&
                            this.toggleModal ? (
                            <Modal
                                isOpen={removing !== null}
                                branded
                                alignText="left"
                                modalHeader="Remove Access"
                                modalBody={this.getMessage(removing)}
                                toggle={this.toggleModal}
                                onCloseClick={this.toggleModal}
                            />
                        ) : (
                            <Modal
                                isOpen={removing !== null}
                                modalBody={this.getMessage(removing)}
                                modalFooterButtons={[
                                    { label: "Yes, remove family member", onClick: () => this.onRemoveConfirmed(true) },
                                    { label: "No, I’ve changed my mind", onClick: () => this.onRemoveConfirmed() }, 
                                ]}
                            />
                        )}
                    </>
                )}

                {removeAction && !removing && (
                    <RemoveMsg 
                        removeAction={removeAction}
                        removingConfirmed={removingConfirmed}
                    />
                )}
            </>
        );
    }
}

ActiveList.propTypes = propTypes;

const mapStateToProps = state => {
    return {
        age: state.domain.age,
        declineProxyWithReason: state.session.serverData
            ? state.session.serverData.declineProxyWithReason
            : false,
        deleteAction: state.common[types.REQUEST_PROXY_CANCEL],
        emailProxyRequestId: state.common.emailProxyRequestId,
        enableProxyRequestV2: state.session.serverData
            ? state.session.serverData.enableProxyRequestV2
            : false,
        showGrantProxyAccess: state.session.serverData
            ? state.session.serverData.showGrantProxyAccess
            : false,
        technicalHelpDeskNumber: state.session.serverData
            ? state.session.serverData.technicalHelpDeskNumber
            : '',
    };
};

const mapDispatchToProps = dispatch => {
    return {
        changeRequestStatus: (proxyRequestId, proxySource, requestType, status) =>
            dispatch({
                type: types.REQUEST_PROXY_CANCEL,
                data: { proxyRequestId, proxySource, requestType, status },
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActiveList);
